export default __webpack_public_path__ + "static/media/49k.ee583774.md";